import PropTypes from 'prop-types';
import React, { memo } from 'react';

import UploadFileDragger from '@/components/UploadFileDragger';

const DynamicFieldFileUpload = ({ ...props }) => {
  return <UploadFileDragger
    isImage={false}
    listType={'picture'}
    multiple={false}
    cropImage={false}
    descriptionText={'uploadFile'}
    {...props}
  />;
};

DynamicFieldFileUpload.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  rules: PropTypes.any,
};

export default memo(DynamicFieldFileUpload);
